var map = {
	"./georgia+helvetica.png": "89d2",
	"./helvetica+georgia.png": "2f47",
	"./lato+lora.png": "52b7",
	"./lora+lato.png": "9ea4",
	"./quattrocento+quattrocento_sans.png": "3806",
	"./quattrocento_sans+quattrocento.png": "99a4",
	"./roboto+roboto_slab.png": "2a6a",
	"./roboto_slab+roboto.png": "58f3",
	"./source_sans+source_serif.png": "0117",
	"./source_serif+source_sans.png": "f443"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4461";